import { jsx as _jsx } from "react/jsx-runtime";
import RoundButton from '../RoundButton/RoundButton';
import { useContext } from 'react';
import { SiteContext } from '../../utils/common';
const HelpButtons = ({ email, classNames, useCustomerSupportEmail = false }) => {
    const { customerSupportEmail } = useContext(SiteContext);
    const mailTo = useCustomerSupportEmail ? customerSupportEmail : email;
    return (_jsx("div", { className: classNames.content, children: _jsx(RoundButton, { icon: "email", ariaLabel: "Email", label: "Email", onClick: () => window.open(`mailto:${mailTo}`), classNames: { container: classNames.roundButton, label: classNames.roundButtonLabel } }) }));
};
export default HelpButtons;
